import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapPublicOnboardings = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/mlap/public_onboarding/show.vue')
    // Public magic-link page — no AppLayout, no global store.
    createVueApp(ShowPage, { props, layout: null })
  }
}
